<div class="card">
  <div class="ng-Header col-xs-12">
    <i nz-icon nzType="form" nzTheme="outline"></i> Add Representative
  </div>
  <div class="searchboxAerar p-3">
    <form [formGroup]="representativeForm" (ngSubmit)="submitForm()">
      <div class="col-md-12">
        <fieldset>
          <legend
            style="font-size: 17px; font-weight: 500; color: rgb(55, 0, 255)"
          >
            Select Representative:
          </legend>
          <div
            class="mb-2 row"
            style="display: flex; justify-content: center; margin-top: 4px"
          >
            <div class="col-md-2 text-right">
              <nz-form-label nzRequired>Representatives</nz-form-label>
            </div>
            <div class="col-md-4">
              <nz-form-item>
                <nz-form-control
                  nzHasFeedback
                  [nzErrorTip]="inspectionConductedBy3ErrorTpl"
                  class="row"
                >
                  <nz-select
                    id="id"
                    nzShowSearch
                    nzAllowClear
                    formControlName="nsdaOfficerId"
                    nzPlaceHolder="Select representative"
                    (ngModelChange)="onSelectOfficer($event)"
                  >
                    <nz-option
                      *ngFor="let officer of completeInspectionListByType"
                      [nzValue]="officer.nsdaOfficerId"
                      [nzLabel]="officer.name"
                    >
                    </nz-option>
                  </nz-select>
                  <ng-template #inspectionConductedBy3ErrorTpl let-control>
                    <ng-container *ngIf="control.hasError('required')">
                      Please Select!
                    </ng-container>
                  </ng-template>
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>
        </fieldset>
        <div
          style="
            text-align: center;
            color: red;
            border-radius: 2px;
            font-size: 20px;
            font-weight: 700;
          "
        >
          OR
        </div>
        <hr />
        <fieldset>
          <legend
            style="font-size: 17px; font-weight: 500; color: rgb(55, 0, 255)"
          >
            Create Representative:
          </legend>
          <div class="mb-2 row" style="display: flex; justify-content: center">
            <div class="col-md-2 text-right">
              <nz-form-label nzRequired>Name</nz-form-label>
            </div>
            <div class="col-md-4">
              <nz-form-item>
                <nz-form-control
                  nzHasFeedback
                  [nzErrorTip]="errorTplForName"
                  [ngClass]="{
                    'is-loading': representativeForm.controls['name'].pending
                  }"
                  class="row"
                >
                  <input
                    nz-input
                    type="text"
                    id="name"
                    placeholder="Name of representative"
                    formControlName="name"
                  />
                  <ng-template #errorTplForName let-control>
                    <ng-container *ngIf="control.hasError('required')">
                      Please input valid name!
                    </ng-container>
                    <ng-container *ngIf="control.hasError('whitespace')"
                      >Please enter valid name</ng-container
                    >
                  </ng-template>
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>
          <div class="mb-2 row" style="display: flex; justify-content: center">
            <div class="col-md-2 text-right">
              <nz-form-label nzRequired>Email</nz-form-label>
            </div>
            <div class="col-md-4">
              <nz-form-item>
                <nz-form-control
                  nzHasFeedback
                  [nzErrorTip]="errorTplForEmail"
                  class="row"
                >
                  <input
                    nz-input
                    type="email"
                    id="email"
                    placeholder="Email for NSDA representative"
                    formControlName="email"
                  />
                  <ng-template #errorTplForEmail let-control>
                    <ng-container *ngIf="control.hasError('required')">
                      Please input valid email!
                    </ng-container>
                    <ng-container *ngIf="control.hasError('whitespace')"
                      >Please enter valid email</ng-container
                    >
                  </ng-template>
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>
          <div class="mb-2 row" style="display: flex; justify-content: center">
            <div class="col-md-2 text-right">
              <nz-form-label nzRequired>Contact No.</nz-form-label>
            </div>
            <div class="col-md-4">
              <nz-form-item>
                <nz-form-control
                  nzHasFeedback
                  [nzErrorTip]="errorTplForContactNumber"
                  class="row"
                >
                  <input
                    nz-input
                    type="text"
                    placeholder="Contact number"
                    formControlName="phone"
                    (keyup)="checkContactNumberIfExist($event.target)"
                  />
                  <div *ngIf="contactNumberAlreadyExist" class="text-danger">
                    <p>This contact number already exist!</p>
                  </div>
                  <ng-template #errorTplForContactNumber let-control>
                    <ng-container *ngIf="control.hasError('required')">
                      Please input Contact Number!
                    </ng-container>
                    <ng-container *ngIf="control.hasError('pattern')">
                      <div>Contact number must be 11 digits</div>
                    </ng-container>
                  </ng-template>
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>
          <div class="mb-2 row" style="display: flex; justify-content: center">
            <div class="col-md-2 text-right">
              <nz-form-label>Designation</nz-form-label>
            </div>
            <div class="col-md-4">
              <nz-form-item>
                <nz-form-control
                  nzHasFeedback
                  [nzErrorTip]="errorTplForName"
                  [ngClass]="{
                    'is-loading': representativeForm.controls['name'].pending
                  }"
                  class="row"
                >
                  <input
                    nz-input
                    type="text"
                    id="designation"
                    placeholder="Designation of representative"
                    formControlName="designation"
                  />
                  <ng-template #errorTplForName let-control>
                    <ng-container *ngIf="control.hasError('required')">
                      Please input valid designation!
                    </ng-container>
                    <ng-container *ngIf="control.hasError('whitespace')"
                      >Please enter valid designation</ng-container
                    >
                  </ng-template>
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>
        </fieldset>
      </div>
      <div class="row justify-content-center media-button">
        <div class="col-xs-6 col-sm-2">
          <button
            type="submit"
            class="btn btn-success active btn-lg btn-block cari border-redius"
            [disabled]="!representativeForm.valid"
          >
            <i nz-icon nzType="save" nzTheme="fill"></i> Save
          </button>
        </div>
        <div class="col-xs-6 col-sm-2">
          <button
            type="button"
            class="btn btn-danger active btn-lg btn-block cari border-redius"
            (click)="resetForm()"
          >
            <i nz-icon nzType="redo" nzTheme="outline"></i> Reset
          </button>
          <br />
        </div>
      </div>
    </form>
  </div>
</div>
